import PageHero from "@/components/PageHero";
import CTASection from "@/sections/CTASection";
import PartnersMarquee from "@/sections/PartnersMarquee";
import { BUSINESS_PARTNERS, SPORTS_PARTNERS } from "@/data/partners";

const HERO_IMG = "https://images.pexels.com/photos/18206310/pexels-photo-18206310.jpeg?w=2400";

function PartnerGroup({ title, items, accent }) {
  return (
    <section className="py-24 sm:py-32 bg-white">
      <div className="container-x">
        <div className="overline text-emerald-brand">{title}</div>
        <h2 className={`font-display font-extrabold text-4xl sm:text-5xl text-navy mt-4 leading-[1.05]`}>
          {title === "Business Partners" ? <>Brands we&apos;ve helped build.</> : <>Sports partnerships.</>}
        </h2>
        <div className="mt-12 grid md:grid-cols-2 gap-6">
          {items.map((p) => (
            <div key={p.name} className="group relative overflow-hidden border border-slate-200 p-10 bg-white hover:border-navy transition-colors">
              <div className={`absolute inset-0 bg-gradient-to-br ${p.accent} opacity-0 group-hover:opacity-100 transition-opacity`} />
              <div className="relative flex flex-col sm:flex-row gap-6 items-start">
                {p.image && (
                  <div className="w-20 h-20 shrink-0 flex items-center justify-center bg-white border border-slate-100 rounded-xl overflow-hidden shadow-sm group-hover:border-slate-200/80 transition-colors p-2">
                    <img src={p.image} alt={p.name} className="w-full h-full object-contain select-none" />
                  </div>
                )}
                <div className="flex-1">
                  <div className="overline text-emerald-brand">{p.category}</div>
                  <div className="mt-2 font-display font-extrabold text-2xl sm:text-3xl text-navy leading-tight">{p.name}</div>
                  <p className="mt-4 text-base text-slate-brand leading-relaxed">{p.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default function Partners() {
  return (
    <div data-testid="partners-page">
      <PageHero
        overline="Partners"
        title={<>Brands &amp; institutions<br /><span className="italic font-light text-gold">we build with.</span></>}
        subtitle="Long-term partnerships across hospitality, retail and sport — built on trust, shared standards and measurable outcomes."
        image={HERO_IMG}
        breadcrumbs={[{ label: "Partners" }]}
      />
      <PartnerGroup title="Business Partners" items={BUSINESS_PARTNERS} />
      <div className="bg-mist">
        <PartnerGroup title="Sports Partners" items={SPORTS_PARTNERS} />
      </div>
      <PartnersMarquee />
      <CTASection />
    </div>
  );
}
